<template>
  <b-overlay 
    :show="servicebusy" 
    variant="dark"
  >
    <b-card-header class="mb-1">
      <b-card-title>{{ relatie.naam }}</b-card-title>
      <b-card-sub-title class="mb-3">
        {{ relatieEndpoint }}
      </b-card-sub-title>
      <b-button-toolbar>
        <b-button 
          variant="dark" 
          @click="getUnits"
        >
          <i class="cui cui-layers" />
          Ophalen units
        </b-button>
        <b-input-group>
          <b-button 
            variant="dark"
            class="ml-2" 
            @click="getService"
          >
            <i class="cui cui-layers" />
            Ophalen service laatste 12 maanden
          </b-button>
          <b-input-group-append>
            <b-input-group-text>
              <b-checkbox v-model="config.filter.prestatie" /> Filter alleen voor prestatie
            </b-input-group-text>
          </b-input-group-append>
          <b-input-group-text>Onderhoudscategorie</b-input-group-text>
          <b-input-group-append>
            <b-radio-group 
              v-model="config.filter.onderhoudscategorie"
              :options="['A','B','C']"
              button-variant="dark"
              buttons
            />
          </b-input-group-append>
          <b-input-group-text>
            <b-checkbox 
              v-model="toggle" 
              switch
            >
              Instellingen
            </b-checkbox>
          </b-input-group-text>
        </b-input-group>
      </b-button-toolbar>
    </b-card-header>
    
    <b-card-body>
      <kpi-instellingen 
        v-if="toggle"
        :afspraken="geselecteerdeAfspraken"
      />

      <b-tabs>
        <b-tab>
          <template slot="title">
            <i class="cui cui-dashboard" /> Dashboard
          </template>
          <b-table 
            v-if="status !== null"
            :items="orderByCountToArray(groupByUnit(countCategorie('TO')),10)"
            :fields="['count','unit']" 
            top-caption
            bordered 
            caption-top
            striped 
            small
            hover
          >
            <template #table-caption>
              Aantal TO
            </template>
            <template #cell(unit)="row">
              {{ row.item.unit.a }}
            </template>
          </b-table>
          <b-container class="py-3">
            <b-card-group>
              <b-card 
                v-for="(count, type,index) in unitsCount" 
                :key="index"
              >
                <div class="h4 m-0">
                  {{ count }}
                </div>
                <small>{{ type }}</small>
              </b-card>
            </b-card-group>
            <b-card-group>
              <b-card 
                v-for="(count, type,index) in typesCount" 
                :key="index"
              >
                <div class="h4 m-0">
                  {{ count }}
                </div>
                <small>{{ type }}</small>
              </b-card>
            </b-card-group>
          </b-container>
        </b-tab>
        <b-tab title="Score">
          <template slot="title">
            <!--- Score op de kpi's  --->
            <i class="fa fa-table" /> Score
          </template>
          <b-button-toolbar class="float-right">
            <b-radio-group 
              v-model="config.modus"
              :options="[{value:'kpi',text:'kpi'},{value:'percentage',text:'%'},{value:'aantal',text:'x'}]"
              button-variant="dark"
              buttons
            />
          </b-button-toolbar>
          <b-card-title>Kpi scores categorie {{ config.filter.onderhoudscategorie }} <small class="text-muted">108 units</small></b-card-title>
          <b-alert 
            :show="!config.filter.prestatie"
            variant="danger"
            class="my-2"
          >
            Niet gefiltert op voor prestatie!
          </b-alert>
          <kpi-tabel 
            :status="status" 
            :units="units"
            :config="config"
          />
        </b-tab>
        <b-tab 
          v-if="units !== null" 
          title="Units"
        >
          <template slot="title">
            <i class="cui cui-layers" /> {{ units.length }} units
          </template>
          <KpiKwartalen 
            v-if="status !== null"
            :units="units" 
            :service="status.service" 
            :prestatie="config.filter.prestatie"
          />
        </b-tab>
        
        <b-tab 
          v-if="status !== null" 
          title="Service"
        >
          <template slot="title">
            <i class="cui cui-layers" /> {{ status.service.length }} service
          </template>

          <status-table 
            :service="status.service" 
            :prestatie="config.filter.prestatie"
          />
        </b-tab>
      </b-tabs>
    </b-card-body>
  </b-overlay>
</template>
<script>

  import { serviceMixin } from '@/mixins/serviceMixin.js';
  import KpiKwartalen from '@/views/kpi/KpiKwartalen.vue';
  import StatusTable from '@/components/kpi/StatusTable.vue';
  import KpiTabel from '../../components/kpi/KpiTabel.vue';
  import KpiInstellingen from '../../views/kpi/KpiInstellingen.vue';

  export default {
    name: 'KpiOverzicht',
    components: {
    KpiKwartalen,
    StatusTable,
    KpiTabel,
    KpiInstellingen
},
    mixins: [ serviceMixin ],
    props: {
      relatie: {
        type: Object,
        required: true
      }
    },
    data() {
      return  {
        toggle: false,
        onderhoudsfirmas: [],
        status: null,
        units: [],
        config: {
          modus: 'kpi',
          toelichting: {
            beschikbaarheid: "Maximaal {0} uur per jaar stilstandtijd toegestaan",
            storingen: "Maximaal {0} storingen per jaar toegestaan",
            reactietijd: "Maximaal {0} uur reactietijd bij storingen toegestaan",
            stilstand: "Maximaal {0} uur stilstand bij storingen toegestaan",
            keuringen: "Maximaal {0} herhaalpunten toegestaan",
            minimale_duur: "Minimaal {0} minuten per onderhoudsbeurt",
            aantal_beurten: "Per {0} stopplaatsen {1} beurten", 
          },
          filter: {
            onderhoudscategorie: 'B',
            ohfirma: null,
            prestatie: true
          },
          instellingen: {
                "B": {
                    percentages: [ 90, 80 ], // percentage score > 90% = groen, > 80% = oranje, < 80% = rood  
                    beschikbaarheid: 24, // max stilstandtijd in uren per jaar
                    storingen: 4,  // max aantal storingen
                    reactietijd: 2, // max reactietijd in uren bij storingen
                    stilstand: 2, // max stilstand in uren bij storingen
                    keo: {
                      minimale_duur: 60,
                      onderhoud: [
                        { 
                            stopplaatsen: 2, // max aantal stopplaatsen
                            beurten: 3,  
                        },
                        { 
                            stopplaatsen: 4, // max aantal stopplaatsen
                            beurten: 4,  
                        },
                        { 
                            stopplaatsen: 9, // max aantal stopplaatsen
                            beurten: 6,  
                        },
                        { 
                            stopplaatsen: 14, // max aantal stopplaatsen
                            beurten: 8,  
                        }
                      ]
                    } ,
                    afwijking: 10, // % afwijking toegestaan van kpi
                    herhaalpunten: 3, // max aantal herhaalingspunten
                    uren_in_jaar: 365 * 24, // aantal uren in een jaar
                }
            }
        },
      }
    },
    computed: {
      relatieEndpoint: function() {
        return `/relatie/${this.relatie.id}`;
      },
      geselecteerdeAfspraken() {
        if (this.config.instellingen[this.config.filter.onderhoudscategorie] == undefined) return this.config.instellingen['B'];
        return this.config.instellingen[this.config.filter.onderhoudscategorie];
      },
      typesCount() {
          var types = {};
          if (this.status == undefined) return types;
          for (let i = 0; i < this.status.service.length; i++) {
              if (types[this.status.service[i].t] == undefined) {
                  types[this.status.service[i].t] = 0;
              }
              types[this.status.service[i].t]++;
          }
          return types;
      },
      unitsCount() {
        var oh = {};
        for (let i = 0; i < this.units.length; i++) {
          if (oh[this.units[i].oh] == undefined) {
            oh[this.units[i].oh] = 0;
          }
          oh[this.units[i].oh]++;
        }
        return oh;
      }
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {    
      countCategorie(categorie) {
        if (this.status.service == undefined) return [];
        return this.status.service.filter((s) => s.c == categorie);
      },
      countType(type) {
        if (this.status.service == undefined) return [];
        return this.status.service.filter((s) => s.t == type);
      },
      groupByUnit(set) {
        return set.reduce((r, a) => {
          r[a.u.id] = [...r[a.u.id] || [], a];
          return r;
        }, {});
      },
      orderByCountToArray(set,n) {
        return Object.keys(set).map((key) => {
          return {
            unit: set[key][0].u,
            count: set[key].length
          }
        }).sort((a, b) => {
          return b.count - a.count;
        }).slice(0, n);
      },
      getService() {
        this.servicebusy = true;
        this.post(`${this.relatieEndpoint}/service`).then(
          (response) => {
            this.status = response.data;
          }
        ).finally(() => {
          this.servicebusy = false;
        });
      },
      getUnits() {
        this.get(`${this.relatieEndpoint}/units`).then(
          (response) => {
            this.units = [...response.data.units];
          }
        );
      },
      cellBackground(value) {
        value = Math.round(value);
        if (value == 3) return 'bg-success text-center';
        if (value == 2) return 'bg-warning text-center';
        if (value == 1) return 'bg-danger text-center';
        return 'default';
      }
    },
  }
</script>